module.exports = __webpack_public_path__ + "img/ZipperWhite.1d2db44b.png";